// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_2ZrFO","container":"index_container_Zem3a","footerNav":"index_footerNav_jc685"};